import { render, staticRenderFns } from "./recommend_template.vue?vue&type=template&id=03af8d7c&scoped=true"
import script from "./recommend_template.vue?vue&type=script&lang=js"
export * from "./recommend_template.vue?vue&type=script&lang=js"
import style0 from "./recommend_template.vue?vue&type=style&index=0&id=03af8d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af8d7c",
  null
  
)

/* custom blocks */
import block0 from "./recommend_template.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports